export default __webpack_public_path__ + "src/assets/Trezor_Mobile.bf7ab36a8261da8db4110981ae15ca2d.svg";